import React, { useEffect, useRef } from "react";
import { sumArrayOfObjects } from "../../Utilitie";
import { RiResetLeftFill } from "react-icons/ri";
import DownloadExcel from "../../Extra/DownloadExcel";
import NoDataFound from "../../Extra/NoDataFound";
import PDDNightingaleChart from "./PDDNightingaleChart";

const LobbyWisePDD = ({
  data,
  barColors,
  selectedMonth,
  setSelectedMonth,
  selectedFilters,
}) => {
  const Years = [...new Set(data.map((d) => d.PDD_YEAR))].sort((a, b) => b - a);
  const year1 = useRef();
  const year2 = useRef();
  const tableRef = [year1, year2];
  const tableHead = [
    "Month",
    "Cases ≤00:30 HRS",
    "Cases >00:30 AND ≤ 01:00 HRS",
    "Cases >01:00 AND ≤ 02:00 HRS",
    "Cases >02:00 AND ≤ 03:00 HRS",
    "Cases >03:00 HRS",
    "Total Cases",
  ];

  const CellBar = ({ value, max, color }) => {
    const width = max ? (value / max) * 100 : 0;
    return (
      <div className="position-relative " style={{ minWidth: "90px" }}>
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 4,
            height: "70%",
            width: `${width}%`,
            backgroundColor: color,
            borderRadius: "3px",
            opacity: 0.35,
            transition: "width 0.7s ease-in-out", // ANIMATION LINE
          }}
        ></div>
        <span className=" fw-bold ">{value}</span>
      </div>
    );
  };
  useEffect(() => {
    setSelectedMonth({});
  }, [selectedFilters]);
  return (
    <div>
      <div className="row align-items-stretch newUiBody">
        <h5 className="bg-dark text-white p-1">Lobby Wise PDD</h5>
        <div className="row">
          {Years.map((y, k) => {
            let fData = data
              .filter((d) => d.PDD_YEAR === y)
              .filter((d) =>
                selectedMonth[`${y}-month`]
                  ? d.PDD_MONTH === selectedMonth[`${y}-month`]
                  : true
              );

            let sum = sumArrayOfObjects(
              fData,
              ["PDD_LOBBY", "PDD_YEAR"],
              [],
              "group_id"
            );
            sum.sort((a, b) => Number(b.TOTAL_CASES) - Number(a.TOTAL_CASES));

            let noOfLobby = [...new Set(sum.map((o) => o.PDD_LOBBY))]?.length;
            let tempTotal = sumArrayOfObjects(fData, [], [], "group_id");
            let total = tempTotal[0];
            // finding max values per column for proportional bar width
            const maxValues = {
              c1: Math.max(...sum.map((s) => s.LESS_THEN_EQUAL_TO_THIRTY_MIN)),
              c2: Math.max(
                ...sum.map((s) => s.MORE_THEN_THIRTY_MIN_LESS_THAN_ONE_HOUR)
              ),
              c3: Math.max(
                ...sum.map((s) => s.MORE_THEN_ONE_HOUR_LESS_THEN_TWO_HOUR)
              ),
              c4: Math.max(
                ...sum.map((s) => s.MORE_THEN_TWO_HOUR_LESS_THEN_THREE_HOUR)
              ),
              c5: Math.max(...sum.map((s) => s.MORE_THEN_THREE_HOURS)),
              total: Math.max(
                ...sum.map(
                  (s) =>
                    s.LESS_THEN_EQUAL_TO_THIRTY_MIN +
                    s.MORE_THEN_THIRTY_MIN_LESS_THAN_ONE_HOUR +
                    s.MORE_THEN_ONE_HOUR_LESS_THEN_TWO_HOUR +
                    s.MORE_THEN_TWO_HOUR_LESS_THEN_THREE_HOUR +
                    s.MORE_THEN_THREE_HOURS
                )
              ),
            };

            return (
              <div className="row align-items-stretch g-2" key={k}>
                <div className={`col-md-8`}>
                  <div className="newUiBody  h-100 w-100">
                    <h5 className="bg-dark text-white d-flex justify-content-center pt-1">
                      {y}{" "}
                      {selectedMonth[y] === y && selectedMonth[y] !== "" && (
                        <div>
                          {`< ${selectedMonth[`${y}-month`]} `}
                          <button
                            className="btn btn-sm btn-outline-light"
                            onClick={() =>
                              setSelectedMonth({
                                ...selectedMonth,
                                [y]: "",
                                [`${y}-month`]: "",
                              })
                            }
                          >
                            <RiResetLeftFill />
                          </button>
                        </div>
                      )}
                    </h5>
                    <div
                      className="table-responsive   h-100 w-100  p-0"
                      style={{ maxHeight: "380px", overflow: "auto" }}
                    >
                      <table
                        className="table newUiTable table-striped table-hover p-0 m-0"
                        ref={tableRef[Years.indexOf(y)]}
                      >
                        <thead
                          className="table-dark sticky-top"
                          style={{ zIndex: 2 }}
                        >
                          <tr>
                            {tableHead.map((th, i) => (
                              <th className="text-wrap" key={i}>
                                {th}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {sum.map((s, j) => {
                            const total =
                              s.LESS_THEN_EQUAL_TO_THIRTY_MIN +
                              s.MORE_THEN_THIRTY_MIN_LESS_THAN_ONE_HOUR +
                              s.MORE_THEN_ONE_HOUR_LESS_THEN_TWO_HOUR +
                              s.MORE_THEN_TWO_HOUR_LESS_THEN_THREE_HOUR +
                              s.MORE_THEN_THREE_HOURS;
                            return (
                              <tr key={j}>
                                <td>{s.PDD_LOBBY}</td>

                                <td>
                                  <CellBar
                                    value={s.LESS_THEN_EQUAL_TO_THIRTY_MIN}
                                    max={maxValues.c1}
                                    color={barColors.c1}
                                  />
                                </td>
                                <td>
                                  <CellBar
                                    value={
                                      s.MORE_THEN_THIRTY_MIN_LESS_THAN_ONE_HOUR
                                    }
                                    max={maxValues.c2}
                                    color={barColors.c2}
                                  />
                                </td>
                                <td>
                                  <CellBar
                                    value={
                                      s.MORE_THEN_ONE_HOUR_LESS_THEN_TWO_HOUR
                                    }
                                    max={maxValues.c3}
                                    color={barColors.c3}
                                  />
                                </td>
                                <td>
                                  <CellBar
                                    value={
                                      s.MORE_THEN_TWO_HOUR_LESS_THEN_THREE_HOUR
                                    }
                                    max={maxValues.c4}
                                    color={barColors.c4}
                                  />
                                </td>
                                <td>
                                  <CellBar
                                    value={s.MORE_THEN_THREE_HOURS}
                                    max={maxValues.c5}
                                    color={barColors.c5}
                                  />
                                </td>
                                <td>
                                  <CellBar
                                    value={s.TOTAL_CASES}
                                    max={maxValues.total}
                                    color={barColors.total}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot
                          className="table-dark sticky-bottom"
                          style={{ zIndex: 2 }}
                        >
                          <tr>
                            <td>Avg</td>
                            <td>
                              {total?.LESS_THEN_EQUAL_TO_THIRTY_MIN
                                ? (
                                    total.LESS_THEN_EQUAL_TO_THIRTY_MIN /
                                    noOfLobby
                                  ).toFixed(1)
                                : 0}
                            </td>
                            <td>
                              {(
                                total?.MORE_THEN_THIRTY_MIN_LESS_THAN_ONE_HOUR /
                                noOfLobby
                              ).toFixed(1) || 0}
                            </td>
                            <td>
                              {(
                                total?.MORE_THEN_ONE_HOUR_LESS_THEN_TWO_HOUR /
                                noOfLobby
                              ).toFixed(1) || 0}
                            </td>
                            <td>
                              {(
                                total?.MORE_THEN_TWO_HOUR_LESS_THEN_THREE_HOUR /
                                noOfLobby
                              ).toFixed(1) || 0}
                            </td>
                            <td>
                              {(
                                total?.MORE_THEN_THREE_HOURS / noOfLobby
                              ).toFixed(1) || 0}
                            </td>
                            <td>
                              {(total?.TOTAL_CASES / noOfLobby).toFixed(1) || 0}
                            </td>
                          </tr>
                          <tr>
                            <td>Total</td>
                            <td>{total?.LESS_THEN_EQUAL_TO_THIRTY_MIN}</td>
                            <td>
                              {total?.MORE_THEN_THIRTY_MIN_LESS_THAN_ONE_HOUR}
                            </td>
                            <td>
                              {total?.MORE_THEN_ONE_HOUR_LESS_THEN_TWO_HOUR}
                            </td>
                            <td>
                              {total?.MORE_THEN_TWO_HOUR_LESS_THEN_THREE_HOUR}
                            </td>
                            <td>{total?.MORE_THEN_THREE_HOURS}</td>
                            <td>{total?.TOTAL_CASES}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                    {fData?.length === 0 ? (
                      <NoDataFound />
                    ) : (
                      <DownloadExcel
                        tableRef={tableRef[Years.indexOf(y)]}
                        fileName={`Crew PDD Lobby Wise ${y}`}
                      />
                    )}
                  </div>
                </div>
                <div className="col-md-4 ">
                  <div className="newUiBody h-100 w-100">
                    <PDDNightingaleChart data={data} year={y} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LobbyWisePDD;
